// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-extend-sharing-container .fi-container {
  background: var(--fi-background-color-extra-light);
}
.fi-extend-sharing-container .fi-container .fi-content {
  padding: 30px 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/extend-sharing/extend-sharing-container/extend-sharing-container.component.scss"],"names":[],"mappings":"AACI;EACI,kDAAA;AAAR;AAEQ;EACI,eAAA;AAAZ","sourcesContent":[".fi-extend-sharing-container {\r\n    .fi-container {\r\n        background: var(--fi-background-color-extra-light);\r\n\r\n        .fi-content {\r\n            padding: 30px 0;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
